import Vue from 'vue';
import Router from 'vue-router';

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
    return originalReplace.call(this, location).catch(err => err);
};

import Home from '@/home/Home';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Admin from '@/pages/Admin';
import ManagerMain from '@/manager/ManagerMain';
import Teacherlist from '@/manager/components/TeacherList';
import TeacherDetail from '@/manager/components/TeacherDetail';
import PayrollSummary from '@/manager/components/PayrollSummary';
import Teachersetting from '@/manager/components/TeacherSetting';
import TeachAreaSetting from '@/manager/components/TeachAreaSetting';
import SystemData from '@/manager/SystemData';
import CustomerMange from '@/manager/CustomerMange';
import CustomerCollect from '@/manager/CustomerCollect';
import Onlinecourse from '@/manager/components/OnlineCourse';
import studydocs from '@/manager/components/StudyDocs';
import HomeWork from '@/manager/components/HomeWork';
import exercise from '@/manager/components/Exercise';
import classroomlist from '@/manager/components/ClassroomList';
import teachbuildinglist from '@/manager/components/TeachBuildingList';
import CourseTable from '@/manager/components/CourseTable';
import StudentCourseTable from '@/home/components/CourseTable';
import EmptyClassroom from '@/home/components/EmptyClassroom';
import StudentCenter from '@/home/components/Center';
import StudentPassword from '@/home/components/Password';
import courseinfolist from '@/manager/components/CourseInfoList';
import Studenlist from '@/manager/components/StudentList';
import currentStudents from '@/manager/components/StudentList';
import ContractProduct from '@/manager/components/ContractProduct';
import Classtasklist from '@/manager/components/ClassTaskList';
import Classtasklistnew from '@/manager/components/ClassTaskListnew';
import ScheduleDetails from '@/manager/components/ScheduleDetails';
// import StudentDetail from '@/manager/components/StudentDetail';
import StudentDetail from '@/manager/components/StudentDetail（copy）';
import Classmanager from '@/manager/components/ClassManager';
import UpdatePass from '@/pages/components/UpdatePass';
import StudentDoc from '@/home/components/StudentDoc';
import Onlinecategory from '@/manager/components/OnlineCategory';
import help from '@/manager/components/Help';
import StudentMain from '@/home/StudentMain';
import authmanagement from '@/manager/components/AuthManagement'
import rolemanagement from '@/manager/components/RoleManagement'
import usermanagement from '@/manager/components/UserManagement'
import Ordercustomer from '@/manager/components/OrderCustomer'
import TemplateSet from '@/manager/components/TemplateSet'
import OnlineDiagnosis from '@/manager/components/OnlineDiagnosis'
import Offlinediagnosis from '@/manager/components/Offlinediagnosis'
import DiagnosisDetail from '@/manager/components/DiagnosisDetail'
import operationlog from '@/manager/components/OperationLog'
import addrecruitment from '@/manager/components/AddRecruitment';
import viewrecruitment from '@/manager/components/ViewRecruitment';
import Classdetails from '@/manager/components/ClassDetails.vue'
import Analyticstatistics from '@/manager/components/Analyticstatistics'
import Datatable from '@/statistics/Datatable'
import DatatableId from '@/statistics/DatatableId'
import salaryview from '@/manager/salary/salaryview.vue'
import mysalary from '@/manager/salary/mysalary.vue'
import FiveLessons from '@/manager/components/FiveLessons.vue'
import SalarPlan from '@/manager/salary/SalarPlan.vue'
import feedBack from '@/manager/afterSales/feedBack.vue'
import communicate from '@/manager/afterSales/communicate.vue'
import fistClass from '@/manager/afterSales/fistClass.vue'
import fiveClass from '@/manager/afterSales/fiveClass.vue'
import weekendReminder from '@/manager/afterSales/weekendReminder.vue'
import weekendTask from '@/manager/afterSales/weekendTask.vue'
import weekendQA from '@/manager/afterSales/weekendQA.vue'
import chatDetail from '@/manager/afterSales/chatDetail.vue'
import chatDetailTask from '@/manager/afterSales/chatDetailTask.vue'
import chatDetailQA from '@/manager/afterSales/chatDetailQA.vue'
import asYouPlease from '@/manager/afterSales/asYouPlease.vue'
// 课消统计
// import CourseSalesStatistics from '@/manager/afterSales/CourseSalesStatistics.vue'
// import CourseSalesStatisticsDetails from '@/manager/afterSales/CourseSalesStatisticsDetails.vue'
// Vue3
import CourseSalesStatistics from '@/manager/createComponents/CourseSalesStatistics.vue'
import CourseSalesStatisticsDetails from '@/manager/createComponents/CourseSalesStatisticsDetails.vue'
import fiveClassDetail from '@/manager/components/FiveClass.vue'
import ClassSchedule from '@/manager/components/ClassSchedule.vue'
import FirstClassHistory from '@/manager/components/FirstClassHistory.vue'
import salesStatistics from '@/manager/components/salesStatistics.vue'
import CourseStatistics from '@/manager/components/CourseStatistics.vue'
import LineChart from "@/manager/components/LineChart.vue"
import TeacherCost from '@/manager/components/TeacherCost.vue'
import HousingManagement from '@/manager/components/HousingManagement.vue'
// import SalarPlan from '@/manager/components/SalarPlan.vue'
import SalarPlanDialog from '@/manager/components/SalarPlanDialog.vue'
import MonthOverallNum from '@/manager/components/MonthOverallNum.vue'
import DayOverallNum from '@/manager/components/DayOverallNum.vue'
import ContractPlan from '@/manager/components/ContractPlan.vue'
import PersonalParticulars from '@/manager/components/PersonalParticulars.vue'
import StudentManagement from '@/manager/components/StudentManagement.vue'
// =================================================================>>>>>>>>>>
// import agencyTasks from '@/manager/assembly/agencyTasks';
import agencyTasks from '@/manager/assembly/agencyTasks-agencyTasks';
import addDelegatedTasks from '@/manager/assembly/addDelegatedTasks';
import taskNameManage from '@/manager/assembly/taskNameManage';
import model from '@/manager/afterSales/model';
import TrainingManagement from '@/initAssembly/TrainingManagement'
import ApprovalManagement from '@/initAssembly/ApprovalManagement'
import TrainingEntrance from '@/initAssembly/TrainingEntrance'
import addQuestionnaire from '@/InitializationFile/addQuestionnaire'
import answerEntrance from '@/InitializationFile/answerEntrance'
import trainingFiles from '@/initAssembly/trainingFiles'
import resultQuery from '@/InitializationFile/resultQuery'
import IntelligentScheduling from '@/IntelligentScheduling/IntelligentScheduling'
import CourseSchedulingRecords from '@/IntelligentScheduling/CourseSchedulingRecords'
import organizationalStructure from '@/teamOrganization/organizationalStructure'
import InterviewManagement from '@/InterviewManagement/InterviewManagement'
import ResumeManagement from '@/InterviewManagement/ResumeManagement'
import templateSettings from '@/InterviewManagement/templateSettings'
import offerFollowUp from '@/InterviewManagement/offerFollowUp'
import PreSchedule from '@/PreSchedule/PreSchedule'
import PreSchedulenew from '@/PreSchedule/PreSchedule-new'
import telephoneCommunicationCalendar from '@/newsMessage-components/telephoneCommunicationCalendar'
import telephoneCommunicationRecord from '@/newsMessage-components/telephoneCommunicationRecord'
import AttendanceManagement from '@/AnonymousLetterManagement/AttendanceManagement'
import LeaveApprovalManagement from '@/AnonymousLetterManagement/LeaveApprovalManagement'
import PaymentApprovalManagement from '@/AnonymousLetterManagement/PaymentApprovalManagement'
import HolidayClassPlan from '@/HolidayClassPlan/HolidayClassPlan'
import OrderAmountApproval from '@/ApprovalManagement/OrderAmountApproval'
import CourseCancellationApproval from '@/ApprovalManagement/CourseCancellationApproval'
import CancelCourseClosureApproval from '@/ApprovalManagement/CancelCourseClosureApproval'
import WeeklyTestScoreRules from '@/WeeklyTestPerformanceManagement/WeeklyTestScoreRules'
import WeeklyTestScoreViewing from '@/WeeklyTestPerformanceManagement/WeeklyTestScoreViewing'
import dataBoard from '@/dataBoard/dataBoard'
import PromotionAndProtectionRulesManagement from '@/PromotionAndProtectionRulesManagement/PromotionAndProtectionRulesManagement'
import IntermediateTeacherGradeProtectionManagement from '@/IntermediateTeacherGradeProtectionManagement/IntermediateTeacherGradeProtectionManagement'
import PromotionRuleManagement from '@/PromotionRuleManagement/PromotionRuleManagement'
import PromotionTaskApproval from '@/TaskApproval/PromotionTaskApproval'
import DowngradeTaskApproval from '@/TaskApproval/DowngradeTaskApproval'
import Map from '@/ApprovalManagement/Map'
import FileSpace from '@/FileSpace/FileSpace'
import fileManagement from '@/FileSpace/fileManagement'
import DownloadManagement from '@/FileSpace/DownloadManagement'
import customerManagement from '@/customerManagement/customerManagement'
import questionnaireManagement from '@/customerManagement/questionnaireManagement'
import dictionaryManaged from '@/dictionaryManaged/dictionaryManaged'
import ProjectSettings from '@/PointsManagement/ProjectSettings'
import PointsDetails from '@/PointsManagement/PointsDetails'
import PointsApproval from '@/PointsManagement/PointsApproval'
import SigningPlan from '@/NewSigningPlanFiles/SigningPlan'
import AddSigningPlan from '@/NewSigningPlanFiles/AddSigningPlan'
import TeacherSignedContract from '@/NewSigningPlanFiles/TeacherSignedContract'
import depositCustomerFunding from '@/CustomerFundingAll/depositCustomerFunding'
import orderFormCustomerFunding from '@/CustomerFundingAll/orderFormCustomerFunding'
import refundCustomerFunding from '@/CustomerFundingAll/refundCustomerFunding'
import offlineCustomerFunding from '@/CustomerFundingAll/offlineCustomerFunding'

import MultiFunctionalUploadView from '@/MultiFunctionalUploadView/MultiFunctionalUploadView'
import LeaveApproval from '@/LeaveApproval/LeaveApproval'
import IntegralExchang from '@/IntegralExchang/IntegralExchang'


import IntroductionToExpandingScienceAndTechnology from '@/IntroductionToExpandingScienceAndTechnology/IntroductionToExpandingScienceAndTechnology'
import courseConsumptionChart from '@/courseConsumptionChart/courseConsumptionChart'
import firstClassChart from '@/courseConsumptionChart/firstClassChart'
import AttendanceRateChart from '@/courseConsumptionChart/AttendanceRateChart'


import rangeQueryMap from '@/rangeQueryMap/rangeQueryMap'
import TeacherClassApproval from '@/TeacherClassApproval/TeacherClassApproval'
import SignInForClass from '@/SignInForClass/SignInForClass'

import ManagementRank from '@/ManagementRank/ManagementRank'
import ComprehensiveFeedback from '@/ComprehensiveFeedback/ComprehensiveFeedback'


import FirstClassEchart from '@/CourseTypeAnalysisEchart/FirstClassEchart'
import LncreaseRateEchart from '@/CourseTypeAnalysisEchart/LncreaseRateEchart'
import AttendanceRateEchart from '@/CourseTypeAnalysisEchart/AttendanceRateEchart'
import CancellationRateEchart from '@/CourseTypeAnalysisEchart/CancellationRateEchart'
import TurnoverRateEchart from '@/CourseTypeAnalysisEchart/TurnoverRateEchart'
import ContinuationRateEChart from '@/CourseTypeAnalysisEchart/ContinuationRateEChart'


import RevenueAndManagement from '@/RevenueAndManagementAll/RevenueAndManagement'
import MyInvoice from '@/RevenueAndManagementAll/MyInvoice'
import InvoiceManagement from '@/RevenueAndManagementAll/InvoiceManagement'


import Onlinesalescompensation from '@/SalescompensationAll/Onlinesalescompensation'
import Offlinesalescompensation from '@/SalescompensationAll/Offlinesalescompensation'
import plannercompensation from '@/SalescompensationAll/plannercompensation'
 
import SummaryAafterFirstClass from '@/SummaryAafterFirstClass/SummaryAafterFirstClass'



import MyApproval from '@/MyApproval/MyApproval'


import theJobTeacher from '@/TeacherManagement/theJobTeacher'
import theJobTeacherDetails from '@/TeacherManagement/theJobTeacherDetails'

import EnrolledStudent from '@/EnrolledStudent/EnrolledStudent'
import LeaveManagement from '@/LeaveManagement/LeaveManagement'

import WxMiniProgram from '@/WxMiniProgram/WxMiniProgram'
import CKEditor from '@/CKEditor/CKEditor'

import AvailableClassScheduling from '@/AvailableClassScheduling/AvailableClassScheduling'
import TeacherScheduling from '@/TeacherScheduling/TeacherScheduling'
import addDelegatedTaskss from '@/TeacherScheduling/addDelegatedTasks';
import TeacherUpgrade from '@/TeacherUpgrade/TeacherUpgrade';


import RosterManagement from '@/InterviewManagement/RosterManagement'
import psychology from '@/manager/afterSales/psychology.vue'


Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: '登录',
      component: Admin,
      meta:{
        title: '登录',
        requireAuth: false,
      }
    },
    {
      path: '/ManagerMain',
      name: '蒙正后台管理系统',
      component: ManagerMain,
      meta:{
        title: '蒙正后台管理系统',
        requireAuth: true,
      },
      children: [
        {
          path: '/customerMange',
          name: '查看客资',
          component: CustomerMange,
          meta:{
            title: '查看客资',
            requireAuth: true,
          }
        },
        {
          path: '/customerCollect',
          name: '添加客资',
          component: CustomerCollect,
          meta:{
            title: '添加客资',
            requireAuth: true,
          }
        },
        {
          path: '/onlinediagnosis',
          name: '线上诊断',
          component: OnlineDiagnosis,
          meta:{
            title: '线上诊断',
            requireAuth: true,
          }
        },
        {
          path: '/offlinediagnosis',
          name: '线下诊断',
          component: Offlinediagnosis,
          meta:{
            title: '线下诊断',
            requireAuth: true,
          }
        },
        {
          path: '/ordercustomer',
          name: '成单客资',
          component: Ordercustomer,
          meta:{
            title: '成单客资',
            requireAuth: true,
          }
        },
        {
          path: '/templateset',
          name: '模板设置',
          component: TemplateSet,
          meta:{
            title: '模板设置',
            requireAuth: true,
          }
        },
        // {
        //   path: '/classtasklist',
        //   name: '课表排课',
        //   component: Classtasklist,
        //   meta:{
        //     title: '课表排课',
        //     requireAuth: true,
        //   }
        // },
        {
          path: '/classtasklist',
          name: '课表排课',
          component: Classtasklistnew,
          meta:{
            title: '课表排课',
            requireAuth: true,
          }
        },
        {
          path: '/classdetails',
          name: '查看课表',
          component: Classdetails,
          meta:{
            title: '查看课表',
            requireAuth: true,
          }
        },
        {
          path: '/onlinecourse',
          name: '网课列表',
          component: Onlinecourse,
          meta:{
            title: '网课列表',
            requireAuth: true,
          }
        },
        {
          path: '/onlinecategory',
          name: '课程类别',
          component: Onlinecategory,
          meta:{
            title: '课程类别',
            requireAuth: true,
          }
        },
        {
          path: '/teacherlist',
          name: '所有讲师',
          component: Teacherlist,
          meta:{
            title: '所有讲师',
            requireAuth: true,
          }
        },
        {
          path: '/teachersetting',
          name: '职级设置',
          component: Teachersetting,
          meta:{
            title: '职级设置',
            requireAuth: true,
          }
        },
        {
          path: '/classmanager',
          name: '所有班级',
          component: Classmanager,
          meta:{
            title: '所有班级',
            requireAuth: true,
          }
        },
        {
          path: '/studentlist',
          name: '所有学生',
          component: Studenlist,
          meta:{
            title: '所有班级',
            requireAuth: true,
          }
        },
        {
          path: '/currentStudents',
          name: '在读学生',
          component: currentStudents,
          meta:{
            title: '在读学生',
            requireAuth: true,
          }
        },
        {
          path: '/ContractPlan',
          name: '签约方案',
          component: ContractPlan,
          meta:{
            title: '签约方案',
            requireAuth: true,
          }
        },
        {
          path: '/SigningPlan',
          name: '签约方案(新)',
          component: SigningPlan,
          meta:{
            title: '签约方案(新)',
            requireAuth: true,
          }
        },
        {
          path: '/AddSigningPlan',
          name: '添加签约方案(新)',
          component: AddSigningPlan,
          meta:{
            title: '添加签约方案(新)',
            requireAuth: true,
          }
        },
        {
          path: '/TeacherSignedContract',
          name: '老师签约',
          component: TeacherSignedContract,
          meta:{
            title: '老师签约',
            requireAuth: true,
          }
        },
        {
          path: '/studydocs',
          name: '学习文档',
          component: studydocs,
          meta:{
            title: '学习文档',
            requireAuth: true,
          }
        },
        {
          path: '/exercise',
          name: '在线测试',
          component: exercise,
          meta:{
            title: '在线测试',
            requireAuth: true,
          }
        },
        {
          path: '/courseinfolist',
          name: '教材列表',
          component: courseinfolist,
          meta:{
            title: '教材列表',
            requireAuth: true,
          }
        },
        {
          path: '/teachbuildinglist',
          name: '教学楼管理',
          component: teachbuildinglist,
          meta:{
            title: '教学楼管理',
            requireAuth: true,
          }
        },
        {
          path: '/classroomlist',
          name: '教室列表',
          component: classroomlist,
          meta:{
            title: '教室列表',
            requireAuth: true,
          }
        },
        {
          path: '/help',
          name: '使用说明',
          component: help,
          meta:{
            title: '使用说明',
            requireAuth: true,
          }
        },
        {
          path: '/usermanagement',
          name: '用户管理',
          component: usermanagement,
          meta:{
            title: '用户管理',
            requireAuth: true,
          }
        },
        {
          path: '/rolemanagement',
          name: '角色管理',
          component: rolemanagement,
          meta:{
            title: '角色管理',
            requireAuth: true,
          }
        },
        {
          path: '/authmanagement',
          name: '权限管理',
          component: authmanagement,
          meta:{
            title: '权限管理',
            requireAuth: true,
          }
        },
        {
          path: '/operationlog',
          name: '操作日志',
          component: operationlog,
          meta:{
            title: '操作日志',
            requireAuth: true,
          }
        },
        {
          path: '/addrecruitment',
          name: '添加招聘',
          component: addrecruitment,
          meta:{
            title: '添加招聘',
            requireAuth: true,
          }
        },
        {
          path: '/viewrecruitment',
          name: '查看招聘',
          component: viewrecruitment,
          meta:{
            title: '查看招聘',
            requireAuth: true,
          }
        },
        {
          path: '/Datatable',
          name: '数据图表',
          component: Datatable,
          meta:{
            title: '数据图表',
            requireAuth: true,
          }
        },
        {
          path: '/ClassSchedule',
          name: '课时统计',
          component: ClassSchedule,
          meta:{
            title: '课时统计',
            requireAuth: true,
          }
        },
        {
          path: '/salesStatistics',
          name: '课销统计',
          component: salesStatistics,
          meta:{
            title: '课销统计',
            requireAuth: true,
          }
        },
        {
          path: '/salaryview',
          name: '薪酬查看',
          component: salaryview,
          meta:{
            title: '薪酬查看',
            requireAuth: true,
          }
        },
        {
          path: '/mysalary',
          name: '我的工资条',
          component: mysalary,
          meta:{
            title: '我的工资条',
            requireAuth: true,
          }
        },
        {
          path: '/SalarPlan',
          name: '薪资方案',
          component: SalarPlan,
          meta:{
            title: '薪资方案',
            requireAuth: true,
          }
        },
        {
          path: '/feedBack',
          name: '教师课后反馈',
          component: feedBack,
          meta:{
            title: '教师课后反馈',
            requireAuth: true,
          }
        },
        {
          path: '/communicate',
          name: '规划师沟通',
          component: communicate,
          meta:{
            title: '规划师沟通',
            requireAuth: true,
          }
        },
        {
          path: '/fistClass',
          name: '首次课计划',
          component: fistClass,
          meta:{
            title: '首次课计划',
            requireAuth: true,
          }
        },
        {
          path: '/fiveClass',
          name: '五次课计划',
          component: fiveClass,
          meta:{
            title: '五次课计划',
            requireAuth: true,
          }
        },
        {
          path: '/HousingManagement',
          name: '房屋管理',
          component: HousingManagement,
          meta:{
            title: '房屋管理',
            requireAuth: true,
          }
        },
        {
          path: '/StudentManagement',
          name: '学管管理',
          component: StudentManagement,
          meta:{
            title: '学管管理',
            requireAuth: true,
          }
        },
        {
          path: '/PersonalParticulars/:id/:time/:name',
          name: '个人资料',
          component: PersonalParticulars,
          meta:{
            title: '个人资料',
            requireAuth: true,
          }
        },
        {
          path: '/teacher-detail/:id',
          name: '教师详细信息',
          component: TeacherDetail,
          props: true,
          meta:{
            title: '教师详细信息',
            requireAuth: true,
          }
        },
        {
          path: '/student-detail/:id/:peagNum',
          name: '学生详细信息',
          component: StudentDetail,
          props: true,
          meta:{
            title: '学生详细信息',
            requireAuth: true,
          }
        },
        {
          path: '/agencyTasks',
          name: '代办任务管理',
          component: agencyTasks,
          props: true,
          meta:{
            title: '代办任务管理',
            requireAuth: true,
          }
        },
        {
          path: '/addDelegatedTasks',
          name: '添加代办任务',
          component: addDelegatedTasks,
          props: true,
          meta:{
            title: '添加代办任务',
            requireAuth: true,
          }
        },
        {
          path: '/taskNameManage',
          name: '任务名称管理',
          component: taskNameManage,
          props: true,
          meta:{
            title: '任务名称管理',
            requireAuth: true,
          }
        },
        {
          path: '/diagnosisdetail',
          name: '诊断信息查看',
          component: DiagnosisDetail,
          meta:{
            title: '诊断信息查看',
            requireAuth: true,
          }
        },
        {
          path: '/CourseStatistics',
          name: "课消统计图",
          component: CourseStatistics,
          meta:{
            title: '课消统计图',
            requireAuth: true,
          }
        },
        {
          path: '/LineChart',
          name: "折线图",
          component: LineChart,
          meta:{
            title: '折线图',
            requireAuth: true,
          }
        },
        {
          path: "/MonthOverallNum",
          name: '月总体课消数',
          component: MonthOverallNum,
          meta:{
            title: '月总体课消数',
            requireAuth: true,
          }
        },
        {
          path: '/DayOverallNum',
          name: '日课消数统计',
          component: DayOverallNum,
          meta:{
            title: '日课消数统计',
            requireAuth: true,
          }
        },
        {
          path: '/model',
          name: '蜡烛',
          component: model,
          meta:{
            title: '蜡烛',
            requireAuth: true,
          }
        },
        {
          path: '/CourseSalesStatistics',
          name: '课消统计',
          component: CourseSalesStatistics,
          meta:{
            title: '课消统计',
            requireAuth: true,
          }
        },
        {
          path: '/CourseSalesStatisticsDetails',
          name: '课消统计详情',
          component: CourseSalesStatisticsDetails,
          meta:{
            title: '课消统计详情',
            requireAuth: true,
          }
        },
        {
          path: '/weekendReminder',
          name: '叮嘱',
          component: weekendReminder,
          meta:{
            title: '叮嘱',
            requireAuth: true,
            // keepAlive: true,
          }
        },
        {
          path: '/weekendTask',
          name: '作业',
          component: weekendTask,
          meta:{
            title: '作业',
            requireAuth: true,
            // keepAlive: true,
          }
        },
        {
          path: '/weekendQA',
          name: '答疑',
          component: weekendQA,
          meta:{
            title: '答疑',
            requireAuth: true,
            // keepAlive: true,
          }
        },
        {
          path: '/chatDetail',
          name: '叮嘱聊天室',
          component: chatDetail,
          meta:{
            title: '叮嘱聊天室',
            requireAuth: true,
          }
        },
        {
          path: '/chatDetailTask',
          name: '作业聊天室',
          component: chatDetailTask,
          meta:{
            title: '作业聊天室',
            requireAuth: true,
          }
        },
        {
          path: '/chatDetailQA',
          name: '答疑聊天室',
          component: chatDetailQA,
          meta:{
            title: '答疑聊天室',
            requireAuth: true,
          }
        },
        {
          path: '/asYouPlease',
          name: '删除历史',
          component: asYouPlease,
          meta:{
            title: '删除历史',
            requireAuth: true,
          }
        },
        {
          path: '/TrainingManagement',
          name: '添加方案',
          component: TrainingManagement,
          meta:{
            title: '添加方案',
            requireAuth: true,
          }
        },
        {
          path: '/ApprovalManagement',
          name: '审批管理',
          component: ApprovalManagement,
          meta:{
            title: '审批管理',
            requireAuth: true,
          }
        },
        {
          path: '/TrainingEntrance',
          name: '培训入口',
          component: TrainingEntrance,
          meta:{
            title: '培训入口',
            requireAuth: true,
          }
        },
        {
          path: '/trainingFiles',
          name: '培训档案',
          component: trainingFiles,
          meta:{
            title: '培训档案',
            requireAuth: true,
          }
        },
        {
          path: '/addQuestionnaire',
          name: '添加问卷',
          component: addQuestionnaire,
          meta:{
            title: '添加问卷',
            requireAuth: true,
          }
        },
        {
          path: '/answerEntrance',
          name: '答题入口',
          component: answerEntrance,
          meta:{
            title: '答题入口',
            requireAuth: true,
          }
        },
        {
          path: '/resultQuery',
          name: '结果查询',
          component: resultQuery,
          meta:{
            title: '结果查询',
            requireAuth: true,
          }
        },
        {
          path: '/IntelligentScheduling',
          name: '智能排课',
          component: IntelligentScheduling,
          meta:{
            title: '智能排课',
            requireAuth: true,
          }
        },
        {
          path: '/CourseSchedulingRecords',
          name: '排课记录',
          component: CourseSchedulingRecords,
          meta:{
            title: '排课排课',
            requireAuth: true,
          }
        },

        {
          path: '/organizationalStructure',
          name: '组织架构',
          component: organizationalStructure,
          meta:{
            title: '组织架构',
            requireAuth: true,
          }
        },
        {
          path: '/InterviewManagement',
          name: '面试管理',
          component: InterviewManagement,
          meta:{
            title: '面试管理',
            requireAuth: true,
          }
        },

        {
          path: '/ResumeManagement',
          name: '简历管理',
          component: ResumeManagement,
          meta:{
            title: '简历管理',
            requireAuth: true,
          }
        },

        {
          path: '/templateSettings',
          name: '模版设置',
          component: templateSettings,
          meta:{
            title: '模版设置',
            requireAuth: true,
          }
        },
        {
          path: '/offerFollowUp',
          name: 'offer跟进',
          component: offerFollowUp,
          meta:{
            title: 'offer跟进',
            requireAuth: true,
          }
        },
        // {
        //   path: '/PreSchedule',
        //   name: '预排课表',
        //   component: PreSchedule,
        //   meta:{
        //     title: '预排课表',
        //     requireAuth: true,
        //   }
        // },
        {
          path: '/PreSchedule',
          name: '预排课表',
          component: PreSchedulenew,
          meta:{
            title: '预排课表',
            requireAuth: true,
          }
        },

        {
          path: '/telephoneCommunicationCalendar',
          name: '电话沟通日历',
          component: telephoneCommunicationCalendar,
          meta:{
            title: '电话沟通日历',
            requireAuth: true,
          }
        },
        {
          path: '/telephoneCommunicationRecord',
          name: '电话沟通记录',
          component: telephoneCommunicationRecord,
          meta:{
            title: '电话沟通记录',
            requireAuth: true,
          }
        },
        {
          path: '/AttendanceManagement',
          name: '考勤管理',
          component: AttendanceManagement,
          meta:{
            title: '考勤管理',
            requireAuth: true,
          }
        },{
          path: '/LeaveApprovalManagement',
          name: '请假审批管理',
          component: LeaveApprovalManagement,
          meta:{
            title: '请假审批管理',
            requireAuth: true,
          }
        },{
          path: '/PaymentApprovalManagement',
          name: '付款审批管理',
          component: PaymentApprovalManagement,
          meta:{
            title: '付款审批管理',
            requireAuth: true,
          }
        },
        {
          path: '/HolidayClassPlan',
          name: '假期课计划',
          component: HolidayClassPlan,
          meta:{
            title: '假期课计划',
            requireAuth: true,
          }
        },
        {
          path: '/OrderAmountApproval',
          name: '成单金额审批',
          component: OrderAmountApproval,
          meta:{
            title: '成单金额审批',
            requireAuth: true,
          }
        },
        {
          path: '/CourseCancellationApproval',
          name: '课消审批',
          component: CourseCancellationApproval,
          meta:{
            title: '课消审批',
            requireAuth: true,
          }
        },
        {
          path: '/CancelCourseClosureApproval',
          name: '取消结课审批',
          component: CancelCourseClosureApproval,
          meta:{
            title: '取消结课审批',
            requireAuth: true,
          }
        },
        {
          path: '/WeeklyTestScoreRules',
          name: '周测成绩等级规则',
          component: WeeklyTestScoreRules,
          meta:{
            title: '周测成绩等级规则',
            requireAuth: true,
          }
        },
        {
          path: '/WeeklyTestScoreViewing',
          name: '周测成绩查看',
          component: WeeklyTestScoreViewing,
          meta:{
            title: '周测成绩查看',
            requireAuth: true,
          }
        },
        {
          path: '/dataBoard',
          name: '数据看板',
          component: dataBoard,
          meta:{
            title: '数据看板',
            requireAuth: true,
          }
        },
        {
          path: '/PromotionAndProtectionRulesManagement',
          name: '晋升保级规则管理',
          component: PromotionAndProtectionRulesManagement,
          meta:{
            title: '晋升保级规则管理',
            requireAuth: true,
          }
        },
        {
          path: '/IntermediateTeacherGradeProtectionManagement',
          name: '中级老师保级管理',
          component: IntermediateTeacherGradeProtectionManagement,
          meta:{
            title: '中级老师保级管理',
            requireAuth: true,
          }
        },
        {
          path: '/PromotionRuleManagement',
          name: '晋升规则管理',
          component: PromotionRuleManagement,
          meta:{
            title: '晋升规则管理',
            requireAuth: true,
          }
        },
        {
          path: '/PromotionTaskApproval',
          name: '晋升任务审批',
          component: PromotionTaskApproval,
          meta:{
            title: '晋升任务审批',
            requireAuth: true,
          }
        },
        {
          path: '/DowngradeTaskApproval',
          name: '降级任务审批',
          component: DowngradeTaskApproval,
          meta:{
            title: '降级任务审批',
            requireAuth: true,
          }
        },
        {
          path: '/Map',
          name: '地图',
          component: Map,
          meta:{
            title: '地图',
            requireAuth: true,
          }
        },
        {
          path: '/FileSpace',
          name: '文件空间',
          component: FileSpace,
          meta:{
            title: '文件空间',
            requireAuth: true,
          }
        },
        {
          path: '/fileManagement',
          name: '文件审批',
          component: fileManagement,
          meta:{
            title: '文件审批',
            requireAuth: true,
          }
        },
        {
          path: '/DownloadManagement',
          name: '下载管理',
          component: DownloadManagement,
          meta:{
            title: '下载管理',
            requireAuth: true,
          }
        },
        {
          path: '/customerManagement',
          name: '客户管理',
          component: customerManagement,
          meta:{
            title: '客户管理',
            requireAuth: true,
          }
        },
        {
          path: '/questionnaireManagement',
          name: '问卷管理',
          component: questionnaireManagement,
          meta:{
            title: '问卷管理',
            requireAuth: true,
          }
        },
        {
          path: '/dictionaryManaged',
          name: '字典管理',
          component:dictionaryManaged,
          meta:{
            title: '字典管理',
            requireAuth: true,
          }
        },
        {
          path: '/ProjectSettings',
          name: '项目设置',
          component:ProjectSettings,
          meta:{
            title: '项目设置',
            requireAuth: true,
          }
        },
        {
          path: '/PointsDetails',
          name: '积分详情',
          component:PointsDetails,
          meta:{
            title: '积分详情',
            requireAuth: true,
          }
        },
        {
          path: '/PointsApproval',
          name: '积分审批',
          component:PointsApproval,
          meta:{
            title: '积分审批',
            requireAuth: true,
          }
        },

        {
          path: '/depositCustomerFunding',
          name: '定金客资',
          component: depositCustomerFunding,
          meta:{
            title: '定金客资',
            requireAuth: true,
          }
        },

        {
          path: '/orderFormCustomerFunding',
          name: '成单客资',
          component: orderFormCustomerFunding,
          meta:{
            title: '成单客资',
            requireAuth: true,
          }
        },

        {
          path: '/refundCustomerFunding',
          name: '退费客资',
          component: refundCustomerFunding,
          meta:{
            title: '退费客资',
            requireAuth: true,
          }
        },

        {
          path: '/offlineCustomerFunding',
          name: '线下客资',
          component: offlineCustomerFunding,
          meta:{
            title: '线下客资',
            requireAuth: true,
          }
        },

        {
          path: '/MultiFunctionalUploadView',
          name: '下载上传',
          component: MultiFunctionalUploadView,
          meta:{
            title: '下载上传',
            requireAuth: true,
          }
        },

        {
          path: '/LeaveApproval',
          name: '请假审批',
          component: LeaveApproval,
          meta:{
            title: '请假审批',
            requireAuth: true,
          }
        },

        {
          path: '/IntegralExchang',
          name: '积分兑换',
          component: IntegralExchang,
          meta:{
            title: '积分兑换',
            requireAuth: true,
          }
        },

        {
          path: '/IntroductionToExpandingScienceAndTechnology',
          name: '扩科转介绍',
          component: IntroductionToExpandingScienceAndTechnology,
          meta:{
            title: '扩科转介绍',
            requireAuth: true,
          }
        },

        {
          path: '/courseConsumptionChart',
          name: '课消图表',
          component: courseConsumptionChart,
          meta:{
            title: '课消图表',
            requireAuth: true,
          }
        },

        {
          path: '/firstClassChart',
          name: '首次课图表',
          component: firstClassChart,
          meta:{
            title: '首次课图表',
            requireAuth: true,
          }
        },

        {
          path: '/rangeQueryMap',
          name: '区域查询',
          component: rangeQueryMap,
          meta:{
            title: '区域查询',
            requireAuth: true,
          }
        },

        {
          path: '/TeacherClassApproval',
          name: '老师课时审批',
          component: TeacherClassApproval,
          meta:{
            title: '老师课时审批',
            requireAuth: true,
          }
        },

        
        {
          path: '/SignInForClass',
          name: '上课签到',
          component: SignInForClass,
          meta:{
            title: '上课签到',
            requireAuth: true,
          }
        },


        {
          path: '/ManagementRank',
          name: '管理职级',
          component: ManagementRank,
          meta:{
            title: '管理职级',
            requireAuth: true,
          }
        },


        
        {
          path: '/ComprehensiveFeedback',
          name: '综合反馈',
          component: ComprehensiveFeedback,
          meta:{
            title: '综合反馈',
            requireAuth: true,
          }
        },

        {
          path: '/AttendanceRateChart',
          name: '到课率图表',
          component: AttendanceRateChart,
          meta:{
            title: '到课率图表',
            requireAuth: true,
          }
        },



        {
          path: '/FirstClassEchart',
          name: '首次课图表',
          component: FirstClassEchart,
          meta:{
            title: '首次课图表',
            requireAuth: true,
          }
        },

        {
          path: '/LncreaseRateEchart',
          name: '新增率图表',
          component: LncreaseRateEchart,
          meta:{
            title: '新增率图表',
            requireAuth: true,
          }
        },

        {
          path: '/AttendanceRateEchart',
          name: '到课率图表',
          component: AttendanceRateEchart,
          meta:{
            title: '到课率图表',
            requireAuth: true,
          }
        },

        {
          path: '/CancellationRateEchart',
          name: '取消率图表',
          component: CancellationRateEchart,
          meta:{
            title: '取消率图表',
            requireAuth: true,
          }
        },
        {
          path: '/TurnoverRateEchart',
          name: '流失率图表',
          component: TurnoverRateEchart,
          meta:{
            title: '流失率图表',
            requireAuth: true,
          }
        },
        {
          path: '/ContinuationRateEChart',
          name: '续报率图表',
          component: ContinuationRateEChart,
          meta:{
            title: '续报率图表',
            requireAuth: true,
          }
        },
        {
          path: '/RevenueAndManagement',
          name: '收支管理',
          component: RevenueAndManagement,
          meta:{
            title: '收支管理',
            requireAuth: true,
          }
        },  

        {
          path: '/InvoiceManagement',
          name: '发票管理',
          component: InvoiceManagement,
          meta:{
            title: '发票管理',
            requireAuth: true,
          }
        }, 

        {
          path: '/MyInvoice',
          name: '我的发票',
          component: MyInvoice,
          meta:{
            title: '我的发票',
            requireAuth: true,
          }
        },

        {
          path: '/Onlinesalescompensation',
          name: '线上销售薪酬',
          component: Onlinesalescompensation,
          meta:{
            title: '线上销售薪酬',
            requireAuth: true,
          }
        },  

        {
          path: '/Offlinesalescompensation',
          name: '线下销售薪酬',
          component: Offlinesalescompensation,
          meta:{
            title: '线下销售薪酬',
            requireAuth: true,
          }
        },  

        {
          path: '/MyApproval',
          name: '我的审批',
          component: MyApproval,
          meta:{
            title: '我的审批',
            requireAuth: true,
          }
        },  

        
        {
          path: '/SummaryAafterFirstClass',
          name: '首次课课后总结',
          component: SummaryAafterFirstClass,
          meta:{
            title: '首次课课后总结',
            requireAuth: true,
          }
        },  


        {
          path: '/theJobTeacher',
          name: '在职教师',
          component: theJobTeacher,
          meta:{
            title: '在职教师',
            requireAuth: true,
          }
        },  
        
        {
          path: '/theJobTeacherDetails/:id',
          name: '在职教师详情',
          component: theJobTeacherDetails,
          meta:{
            title: '在职教师详情',
            requireAuth: true,
          }
        },  

        {
          path: '/EnrolledStudent',
          name: '正式学生',
          component: EnrolledStudent,
          meta:{
            title: '正式学生',
            requireAuth: true,
          }
        },


        {
          path: '/LeaveManagement',
          name: '请假管理',
          component: LeaveManagement,
          meta:{
            title: '请假管理',
            requireAuth: true,
          }
        },

        {
          path: '/WxMiniProgram',
          name: '小程序版本',
          component: WxMiniProgram,
          meta:{
            title: '小程序版本',
            requireAuth: true,
          }
        },

        {
          path: '/CKEditor',
          name: '文档中心',
          component: CKEditor,
          meta:{
            title: '文档中心',
            requireAuth: true,
          }
        },


        {
          path: '/AvailableClassScheduling',
          name: '可排课时',
          component: AvailableClassScheduling,
          meta:{
            title: '可排课时',
            requireAuth: true,
          }
        },


        {
          path: '/TeacherScheduling',
          name: '内部老师排课',
          component: TeacherScheduling,
          meta:{
            title: '内部老师排课',
            requireAuth: true,
          }
        },


        {
          path: '/addDelegatedTaskss',
          name: '添加内部老师排课任务',
          component: addDelegatedTaskss,
          props: true,
          meta:{
            title: '添加内部老师排课任务',
            requireAuth: true,
          }
        },

        {
          path: '/TeacherUpgrade',
          name: '老师升级审批',
          component: TeacherUpgrade,
          props: true,
          meta:{
            title: '老师升级审批',
            requireAuth: true,
          }
        },


         {
          path: '/RosterManagement',
          name: '花名册管理',
          component: RosterManagement,
          meta:{
            title: '花名册管理',
            requireAuth: true,
          }
        },


        {
          path: '/psychology',
          name: '心理学课后反馈',
          component: psychology,
          meta:{
            title: '心理学课后反馈',
            requireAuth: true,
          }
        },


        {
          path: '/plannercompensation',
          name: '规划师薪酬',
          component: plannercompensation,
          meta:{
            title: '规划师薪酬',
            requireAuth: true,
          }
        },  


        

      ]
    },
  ]
})


// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) {
//     if (window.localStorage.getItem('teacher') || window.localStorage.getItem("admin")) {
//       next()
//     } else {
//       next({ path: '/'})
//     }
//   }
//   next()
// })


export default router






// WEBPACK FOOTER //
// ./src/router/index.js